import CountryAutocomplete from "components/CountryAutocomplete";
import AddressAutocomplete from "components/shared/AddressAutocomplete";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import { useTranslation } from "react-i18next";

import type { TBeneficiaryFormData } from "../types";

interface IAdressStep {
    /**
     * React useForm() hooks
     */
    useFormData: TBeneficiaryFormData;
    stepTitle: string;
    stepSubtitle: string;
    indexStep: number;
}

const AdressStep = ({ useFormData, stepTitle, stepSubtitle, indexStep }: IAdressStep) => {
    const [t] = useTranslation();
    const { control, errors, setValue, watch } = useFormData;
    const streetValue = watch("street");

    return (
        <>
            <h3 className="form-section-title">
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            <div className="form-fields">
                <AddressAutocomplete
                    control={control}
                    setValue={setValue}
                    streetValue={streetValue}
                    error={errors.street}
                />
                <div className="form-component-wrapper thirty">
                    <TextFormComponent
                        label={t("NewBeneficiary.ZIPCode")}
                        control={control}
                        controlName="zipCode"
                        placeholder={t("AddressPlaceholders.ZipCode")}
                    />
                    <TextFormComponent
                        label={t("NewBeneficiary.City")}
                        control={control}
                        controlName="city"
                        placeholder={t("AddressPlaceholders.City")}
                    />
                </div>
                <CountryAutocomplete control={control} errors={errors} />
            </div>
        </>
    );
};

export default AdressStep;
